export default __webpack_public_path__ + "static/va-88dc9bbc061ccd327f66638e67697b46.svg";